import {
  CDocket,
  CDataRequest,
  CCustomSeachFields,
  CCounty,
  CAps,
  CWarrantStatusHistory,
} from "./../app-services/system-interface";
import { Component, OnInit } from "@angular/core";
import { GetDataService } from "../app-services/manage-data.service";
// Grid

import { AgGridNg2 } from "ag-grid-angular";
import { ViewChild } from "@angular/core";

import * as moment from "moment";
//import { ExecFileOptionsWithStringEncoding } from 'child_process';
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material";
import { Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
export interface DialogData {
  message: "erro";
  messageId: 0;
}
export interface CourtWarrentSatus {
  wrtEarliestEvictDate: any;
  wrtLastDateDeliver: any;
  wrtLastDateReceive: any;
  wrtReSubmit: any;
  wrtSignedDate: any;
  wrtStatusComments: any;
  wrtStatusIssuedComment: any;
  wrtStatusSignRejectB: any;
}
@Component({
  selector: "app-browse-cases",
  templateUrl: "./browse-cases.component.html",
  styleUrls: ["./browse-cases.component.scss"],
})
export class BrowseCasesComponent implements OnInit {
  courtWarrentSatus: CourtWarrentSatus = {
    wrtEarliestEvictDate: "",
    wrtLastDateDeliver: "",
    wrtLastDateReceive: "",
    wrtReSubmit: "",
    wrtSignedDate: "",
    wrtStatusComments: "",
    wrtStatusIssuedComment: "",
    wrtStatusSignRejectB: "",
  };
  // // Grid
  @ViewChild("agGrid") agGrid: AgGridNg2;
  @ViewChild("agGridCharges") agGridCharges: AgGridNg2;
  @ViewChild("agCusomSearch") agCusomSearch: AgGridNg2;
  @ViewChild("agWarrantStatus") agWarrantStatus: AgGridNg2;
  courtStatusType: any;
  panelOpenState = false;

  public eiExecutedby: string;
  public eievictioncomments: string;
  public docketNumber: number;
  private oneCDocket = new CDocket();
  private oneAps = new CAps();
  private warrantStatusHistory = [];
  public WrtType;
  public wrtrowid;
  public WrtStatus; // comercialResidential;
  public defaultAfter;
  public wrtBankruptcy = false;
  public wrtAnimalControl = false;
  public wrtForeClosure = false;
  public wrtapsnolonger = false;
  public wrtdate;
  public wrtCloseDate;
  public eievictiondate;
  public tenantList = [];
  public noticeOfEviction = [];
  public evictionDetail = [];
  public wrtVacatedSatus: boolean;
  // public customeSearchList = [];
  public charges = [];
  public approvalStatus = [];
  public OrderToShowcase = [];
  public customSearchData = [];
  step = -1;
  itemPerPage: number;
  currentPage: number;
  public loggedUser;

  private gridApi;
  private gridColumnApi;
  private columnDefs;
  private rowSelection;

  public selectedDeviceObj: string;
  private dataRecordLink: any;
  private dataRecord = {};

  private gridCustomSearchAPi;
  public cDataRequest = new CDataRequest();
  public searchRequest;
  public searchKey;
  public docketToSearch: string;
  public cCustomSeachFields = new CCustomSeachFields();
  public cCounty = [];
  public selectOneCounty: string;
  public marshalStringConnection: string;
  public searchWithMarshal = {};
  public referralSource = [
    { id: 1, description: "Marshals Observatoin" },
    { id: 2, description: "Landlord" },
    { id: 3, description: "Landlords Attorney" },
    { id: 4, description: "Court Ordered" },
    { id: 5, description: "GAL" },
    { id: 6, description: "Legal Services" },
    { id: 7, description: "Social Worker" },
    { id: 8, description: "Tenant" },
    { id: 9, description: "Medical Provider" },
    { id: 10, description: "Process Server" },
  ];
  public apsReferralSource: number;
  public apsany65yearold: string;
  public apsmentalphysicalyesno: string;
  public apsEvictType: string;
  public wrtStatusSignReject: string;

  constructor(private dataServer: GetDataService, public dialog: MatDialog) {}
  openDialog1() {
    this.dialog.open(DialogElementsDialogBrowse, {
      data: {
        message:
          "Docket doesn't exists or you are not authorized, please contact the administrator",
      },
    });
  }

  evictionDetailColumns = [
    {
      headerName: "Served Date",
      field: "eiNOEDateServed",
      width: 115,
      cellFormatter: function (data) {
        return moment.utc(data.value).format("L");
      },
    },
    {
      headerName: "Scheduled Date",
      field: "eievictiondateschedule",
      width: 130,
      hide: false,
      cellFormatter: function (data) {
        return moment.utc(data.value).format("L");
      },
    },
    {
      headerName: "Approx Time",
      field: "eiEvictionTime",
      width: 115,
      sortable: true,
      filter: true,
    },
    {
      headerName: "Dkt Ref #",
      field: "eiCrossRefDocket",
      width: 115,
      sortable: true,
      filter: true,
    },
    {
      headerName: "",
      suppressMenu: true,
      suppressSorting: true,
      width: 100,
      template: ` <button type="button" style="height: 25px">Comment</button>
            `,
    },
    {
      headerName: "",
      suppressMenu: true,
      suppressSorting: true,
      width: 100,
      template: `<button type="button" style="height: 25px">Move Form</button>
          `,
    },
    {
      headerName: "EXEC Date",
      field: "Execution_Date_time",
      width: 225,
      hide: false,
      cellFormatter: function (data) {
        return moment.utc(data.value).format("MM/DD/YYYY hh:mm:ss");
      },
    },
    {
      headerName: "RTN to Court",
      field: "Date_Return_2_Court",
      width: 120,
      hide: false,
      cellFormatter: function (data) {
        if (data.value == "1900-01-01T00:00:00.000Z") {
          return " / / ";
        } else {
          return moment.utc(data.value).format("L");
        }
      },
    },
    {
      headerName: "Cancel Eviction",
      field: "eiCrossRefDocket",
      width: 225,
      hide: false,
      checkboxSelection: true,
      cellFormatter: function (data) {
        return true;
      },
    },
  ];

  chargesColumns = [
    {
      headerName: "Date Performed",
      field: "serviceperformdate",
      cellFormatter: function (data) {
        return moment(data.value).format("L");
      },
    },
    {
      headerName: "Service Performed",
      field: "servicedescription",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Sercice Cost",
      field: "servicebasecost",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Amt Billed",
      field: "servicecostperitem",
      valueFormatter: this.currencyFormatter(2),
      sortable: true,
      filter: true,
    },
    {
      headerName: "Service Bce",
      field: "ServiceCurrentBlce",
      sortable: true,
      filter: true,
    },
  ];

  customSearchColumns = [
    {
      headerName: "Docket Numbe",
      field: "wrtDocketNumber",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Tenant F Name",
      field: "wrttenantfirstname",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Tenant L Name",
      field: "wrttenantlastname",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Address",
      field: "wrtPremisesAddress",
      sortable: true,
      filter: true,
    },
  ];

  currencyFormatter(params) {
    return "£" + this.formatNumber(params);
  }

  warrentStatusColumns = [
    {
      headerName: "Date",
      field: "histStatusDate",
      width: 115,
      cellFormatter: function (data) {
        return moment(data.value).format("L");
      },
    },
    {
      headerName: "Status",
      field: "histStatus",
      width: 100,
      sortable: true,
      filter: true,
    },
    {
      headerName: "Description",
      field: "histStatusNotes",
      width: 500,
      sortable: true,
      filter: true,
    },
  ];

  ngOnInit() {
    // this.courtStatusType = "NONE";
    this.selectedDeviceObj = "Marshal Guida";

    this.loggedUser = JSON.parse(sessionStorage.getItem("userDetails"));

    this.cCounty = [];
    this.selectOneCounty = "Select one....";
    this.cCounty.push({ name: "NEW YORK" });
    this.cCounty.push({ name: "QUEENS" });
    this.cCounty.push({ name: "BRONX" });
    this.cCounty.push({ name: "RICHMOND" });
    this.cCounty.push({ name: "KINGS" });

    this.cCustomSeachFields.county = "";
    this.cCustomSeachFields.number = "";
    this.cCustomSeachFields.year = "";
    this.cCustomSeachFields.docket = "";
    this.cCustomSeachFields.crossRef = "";
    this.cCustomSeachFields.tenantFirstName = "";
    this.cCustomSeachFields.tenantLastName = "";
    this.cCustomSeachFields.landLordName = "";
    this.cCustomSeachFields.premisesAddress = "";
  }

  getAllMarshal(searchKey) {
    this.dataServer.doGetMarshal(searchKey).subscribe(
      (data) => {
        this.initializeObjMarshal(data);
      },
      (err) => {
        // console.log(err);
      }
    );
  }

  initializeObjMarshal(data) {
    this.dataRecord = data;
  }

  async searchDocket() {
    this.oneAps = new CAps();
    this.oneCDocket = new CDocket();
    const docket = {
      docketNumber: this.docketToSearch,
      AttnyRowId: this.loggedUser.AttnyRowId,
    };

    this.itemPerPage = 10;
    this.currentPage = 1;
    this.searchKey = this.searchRequest;
    await this.getBrowseCases(docket).then((responseData) => {
      if (responseData === "Not Record Found") {
        this.openDialog1();
      } else {
        console.log("This is the warrant response", responseData);
        this.sanitizedDocket(responseData);

        // Search for Tenants
        this.getUnderTenants({ docketNumber: responseData[0].wrtrowid }).then(
          (responseData: any) => {
            this.tenantList = responseData;
          }
        );
        this.getOrderToShowcase(docket).then((responseData) => {
          this.OrderToShowcase = [];
          var data: any = responseData;
          if (responseData[0].oscwhocallfromcourt === "Not Record Found") {
            data = [];
          } else {
            this.OrderToShowcase = data;
          }
        });

        // this.getNoticeOfEviction(docket).then((responseData: any) => {
        //   this.noticeOfEviction = responseData;
        // });

        // Fixed when not found
        this.getNoticeOfEviction(docket).then((responseData: any) => {
          if (responseData == "Not Record Found") {
            this.noticeOfEviction = [];
          } else {
            this.noticeOfEviction = responseData;
          }
        });

        this.getNoticeOfEvictionDetail(docket).then((responseData: any) => {
          var data: any = responseData;
          if (data[0].eievictioncomments === "Not Record Found") {
            data = [];
          }
          this.evictionDetail = data;
        });

        this.getCharges(docket).then((responseData: any) => {
          this.charges = responseData;
        });

        this.getAps(docket).then((responseData: any) => {
          this.sanitizeAPS(responseData);
        });
        this.getWarrentstatushistory(docket).then((responseData: any) => {
          if (responseData.length > 0) {
            this.warrantStatusHistory = responseData[0];
          }
        });
        this.getApprovalStatus(docket).then((responseData: any) => {
          this.approvalStatus = responseData;
        });
        this.getWarrantCourtStatus(docket).then((responseData: any) => {
          console.log("this is warrant court status ", responseData[0]);

          this.courtWarrentSatus.wrtStatusSignRejectB =
            responseData[0].wrtStatusSignReject;

          if (responseData[0].wrtEarliestEvictDate == null) {
            this.courtWarrentSatus.wrtEarliestEvictDate = "N/A";
          } else {
            this.courtWarrentSatus.wrtEarliestEvictDate = moment(
              responseData[0].wrtEarliestEvictDate
            ).format("MM-DD-YYYY HH:mm:ss");
          }

          if (responseData[0].wrtLastDateDeliver == null) {
            this.courtWarrentSatus.wrtLastDateDeliver = "N/A";
          } else {
            this.courtWarrentSatus.wrtLastDateDeliver = moment(
              responseData[0].wrtLastDateDeliver
            ).format("MM-DD-YYYY HH:mm:ss");
          }

          if (responseData[0].wrtLastDateReceive == null) {
            this.courtWarrentSatus.wrtLastDateReceive = "N/A";
          } else {
            this.courtWarrentSatus.wrtLastDateReceive = moment(
              responseData[0].wrtLastDateReceive
            ).format("MM-DD-YYYY HH:mm:ss");
          }

          this.courtWarrentSatus.wrtStatusIssuedComment =
            responseData[0].wrtStatusIssuedComment;

          this.courtWarrentSatus.wrtStatusComments =
            responseData[0].wrtStatusComments;

          this.courtStatusType = responseData[0].myStatus;
          this.approvalStatus = responseData;
        });
      }
    });
  }

  async getBrowseCases(keySearch: any) {
    const dataResponse = await this.dataServer
      .doGetBrowseCases("Browse", keySearch)
      .toPromise()
      .catch();
    return dataResponse;
  }
  async getUnderTenants(keySearch: any) {
    const dataResponse = await this.dataServer
      .doGetUnderTenants("Browse", keySearch)
      .toPromise()
      .catch();
    return dataResponse;
  }
  async getOrderToShowcase(keySearch: any) {
    const dataResponse = await this.dataServer
      .doOrderToShowcase("Browse", keySearch)
      .toPromise()
      .catch();
    return dataResponse;
  }
  async getNoticeOfEviction(keySearch: any) {
    const dataResponse = await this.dataServer
      .doGetNoticeOfEviction(keySearch)
      .toPromise()
      .catch();
    return dataResponse;
  }

  async getNoticeOfEvictionDetail(searchKey) {
    this.cDataRequest.action = "search_evictionDetail";
    this.cDataRequest.keySearch = searchKey;
    const dataResponse = await this.dataServer
      .doGetEvictionDetail(this.cDataRequest)
      .toPromise()
      .catch();
    return dataResponse;
  }
  async getCharges(keySearch: any) {
    this.cDataRequest.action = "search_charges";
    this.cDataRequest.keySearch = keySearch;
    const dataResponse = await this.dataServer
      .doGetCharges(this.cDataRequest)
      .toPromise()
      .catch();
    return dataResponse;
  }
  async getAps(keySearch: any) {
    const dataResponse = await this.dataServer
      .doGetAps(keySearch)
      .toPromise()
      .catch();
    return dataResponse;
  }
  async getWarrentstatushistory(keySearch: any) {
    const dataResponse = await this.dataServer
      .doGetWarrentstatushistory(keySearch)
      .toPromise()
      .catch();
    return dataResponse;
  }
  async getApprovalStatus(searchKey: any) {
    this.cDataRequest.action = "approvalStatus";
    this.cDataRequest.keySearch = searchKey;
    const dataResponse = await this.dataServer
      .doGetApprovalStatus(this.cDataRequest)
      .toPromise()
      .catch();
    return dataResponse;
  }

  async getWarrantCourtStatus(searchKey: any) {
    // console.log("its here", searchKey);
    this.cDataRequest.action = "approvalStatus";
    this.cDataRequest.keySearch = searchKey;
    const dataResponse = await this.dataServer
      .doWarrantCourtStatus("", this.cDataRequest)
      .toPromise()
      .catch();
    // console.log("response from warrant court status", dataResponse);
    return dataResponse;
  }

  sanitizedDocket(data: any) {
    this.oneCDocket = data[0];
    this.WrtType = this.oneCDocket.WrtType.replace(/ /g, "");
    this.WrtStatus = this.oneCDocket.wrtstatus.replace(/ /g, "");
    if (this.oneCDocket.wrtBankruptcy === "Y") {
      this.wrtBankruptcy = true;
    } else {
      this.wrtBankruptcy = false;
    }
    if (this.oneCDocket.wrtAnimalControl === "Y") {
      this.wrtAnimalControl = true;
    } else {
      this.wrtAnimalControl = false;
    }
    if (this.oneCDocket.wrtForeClosure === "Y") {
      this.wrtForeClosure = true;
    } else {
      this.wrtForeClosure = false;
    }

    this.wrtVacatedSatus = this.oneCDocket.wrtVacatedSatus;
    this.wrtdate = this.oneCDocket.wrtdate;
    this.wrtCloseDate = this.oneCDocket.wrtCloseDate;
    this.eievictiondate = this.oneCDocket.eievictiondate;
    this.wrtStatusSignReject = this.oneCDocket.wrtStatusSignReject.replace(
      / /g,
      ""
    );
  }

  sanitizeAPS(data: any) {
    if (data.length > 0) {
      let d = "";
      this.oneAps = data[0];

      if (this.oneAps.wrtApsNLongerTenant === null) {
        this.wrtapsnolonger = false;
      } else {
        this.wrtapsnolonger = true;
      }

      d = this.oneAps.apsEarliestevictdate;
      this.oneAps.apsEarliestevictdate =
        d.substring(0, 4) + "-" + d.substring(4, 6) + "-" + d.substring(6, 8);

      d = this.oneAps.apsMarshalContactPhone;
      this.oneAps.apsMarshalContactPhone =
        d.substring(0, 3) + "-" + d.substring(3, 6) + "-" + d.substring(6, 10);

      d = this.oneAps.apslandlordphone;
      this.oneAps.apslandlordphone =
        d.substring(0, 3) + "-" + d.substring(3, 6) + "-" + d.substring(6, 10);
      d = this.oneAps.apslandlordattnyphone;
      this.oneAps.apslandlordattnyphone =
        d.substring(0, 3) + "-" + d.substring(3, 6) + "-" + d.substring(6, 10);
      d = this.oneAps.apslandlordsuperphone;
      this.oneAps.apslandlordsuperphone =
        d.substring(0, 3) + "-" + d.substring(3, 6) + "-" + d.substring(6, 10);

      this.apsReferralSource = Number(this.oneAps.apsReferralSource);

      this.apsany65yearold = this.oneAps.apsany65yearold;
      this.apsmentalphysicalyesno = this.oneAps.apsmentalphysicalyesno;
      this.apsEvictType = this.oneAps.apsEvictType.replace(/\s/g, "");
    }
  }

  getCustomSearch(e) {
    if (this.cCustomSeachFields.premisesAddress === "") {
      this.cCustomSeachFields.premisesAddress = "premisesAddress";
    }
    if (this.cCustomSeachFields.landLordName === "") {
      this.cCustomSeachFields.landLordName = "landLordName";
    }
    this.cCustomSeachFields.wrtAttnyRowid = this.loggedUser.AttnyRowId;
    this.dataServer.doCustomSearch(this.cCustomSeachFields).subscribe(
      (data) => {
        this.initializeObjCustomSearch(data);
      },
      (err) => {
        // console.log(err);
      }
    );
  }

  initializeObjCustomSearch(data) {
    this.agCusomSearch.api.setRowData(data);
    // this.customSearchData = data;
    // console.log(this.customSearchData);
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  onSelectionChanged(params) {
    console.log(params);
  }

  onChangeDropdown(sender, newObj, wholeObj) {
    this.marshalStringConnection = newObj;
    this.ngOnInit();
  }

  onGridReady(params) {
    // console.log(params);
  }

  onRowClicked(sender, event: any) {
    console.log("this is eviction comment");
    console.log(event.eievictioncomments);
    this.eiExecutedby = event.eiExecutedby;

    if (event.eievictioncomments === "Not Record Found") {
      this.eievictioncomments = "";
    } else {
      this.eievictioncomments = event.eievictioncomments;
    }

    if (sender === "customsearch") {
      const docket = '{"searchKey"' + ":" + event.data.wrtDocketNumber + "}";
      this.docketToSearch = event.data.wrtDocketNumber;
      this.searchRequest = JSON.parse(docket);
      this.searchDocket();
    }
  }

  onCellClicked(event) {}
  numberValueParser(params) {
    return Number(params.newValue);
  }
  formatNumber(number) {
    return Math.floor(number)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  getDropDownChange(sender, value) {
    this.cCustomSeachFields.county = value;
  }
}

@Component({
  selector: "dialog-elements-dialog",
  templateUrl: "infomessage.html",
})
export class DialogElementsDialogBrowse {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}
}
